import { createRouter, createWebHistory } from 'vue-router'
import { getToken } from '@/utils/auth'

const Layout = () => import('@/layout/index.vue')

export const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { hidden: true }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: { title: '儀表板', icon: 'HomeFilled' }
      }
    ]
  },
  {
    path: '/system',
    component: Layout,
    meta: { title: '系統管理', icon: 'Setting' },
    children: [
      {
        path: 'user',
        name: 'SysUser',
        component: () => import('@/views/system/user/index.vue'),
        meta: { title: '使用者管理', icon: 'User' }
      },
      {
        path: 'role',
        name: 'SysRole',
        component: () => import('@/views/system/role/index.vue'),
        meta: { title: '角色管理', icon: 'UserFilled' }
      },
      {
        path: 'menu',
        name: 'SysMenu',
        component: () => import('@/views/system/menu/index.vue'),
        meta: { title: '選單管理', icon: 'Menu' }
      },
      {
        path: 'log',
        name: 'SysLog',
        component: () => import('@/views/system/log/index.vue'),
        meta: { title: '操作日誌', icon: 'Document' }
      },
      {
        path: 'file',
        name: 'SysFile',
        component: () => import('@/views/system/file/index.vue'),
        meta: { title: '檔案管理', icon: 'Folder' }
      }
    ]
  },
  {
    path: '/water',
    component: Layout,
    meta: { title: '水域安全管理' },
    children: [
      {
        path: 'section',
        name: 'WaterSection',
        component: () => import('@/views/water/section/index.vue'),
        meta: { title: '水域河段管理' }
      },
      {
        path: 'alert',
        name: 'WaterAlert',
        component: () => import('@/views/water/alert/index.vue'),
        meta: { title: '警示通知管理' }
      },
      {
        path: 'activity',
        name: 'WaterActivity',
        component: () => import('@/views/water/activity/index.vue'),
        meta: { title: '活動項目管理' }
      },
      {
        path: 'time-slot',
        name: 'WaterTimeSlot',
        component: () => import('@/views/water/time-slot/index.vue'),
        meta: { title: '時段管理' }
      },
      {
        path: 'news',
        name: 'WaterNews',
        component: () => import('@/views/water/news/index.vue'),
        meta: { title: '最新消息管理' }
      },
      {
        path: 'insurance',
        name: 'WaterInsurance',
        component: () => import('@/views/water/insurance/index.vue'),
        meta: { title: '保險專區管理' }
      },
      {
        path: 'record',
        name: 'WaterRecord',
        component: () => import('@/views/water/record/index.vue'),
        meta: { title: '下水上岸管理' }
      },
      {
        path: 'lottery',
        name: 'WaterLottery',
        component: () => import('@/views/water/lottery/index.vue'),
        meta: { title: '抽獎機會管理' }
      }
    ]
  },
  {
    // 版本頁：不掛選單、不進權限樹，直接輸入網址就能看，免登入
    path: '/version',
    name: 'Version',
    component: () => import('@/views/version/index.vue'),
    meta: { hidden: true, public: true }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/error/404.vue'),
    meta: { hidden: true }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to) => {
  // 公開頁（版本頁）不做登入判斷
  if (to.meta.public) return true

  const hasToken = getToken()
  if (to.path === '/login') {
    return hasToken ? { path: '/' } : true
  }
  if (!hasToken) {
    return { path: '/login', query: to.fullPath !== '/' ? { redirect: to.fullPath } : {} }
  }
  return true
})

export default router
